// extracted by mini-css-extract-plugin
module.exports = {"spacing":"Spacing_spacing__VlaaF","tiny":"Spacing_tiny__2dBGA","small":"Spacing_small__B3JOt","medium":"Spacing_medium__5hA2Y","large":"Spacing_large__HymPr"};